<template>
<DIV
  class="badge border"
>
  <ItpIcon
    icon="ic:baseline-currency-exchange"
  >
  </ItpIcon>
  <span>
    {{ value.anchor }}
  </span>
  <span
    v-if="value.description"
  >
    {{ value.description }}
  </span>
  <span
    class="ml-2"
    v-if="source"
  >
    <ItpIcon
      icon="ic:baseline-cable"
    >
    </ItpIcon>
    <span>
      {{ source }}
    </span>
  </span>
</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcExchangeRateDateRuleDisplay extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  source!: string;

  @Watch('source')
  onSource(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("source")
  }

  @Prop({
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcExchangeRateDateRuleDisplay", UcExchangeRateDateRuleDisplay);

</script>